export const FeaturedBots = [
  {
    avatar: "https://cdn.botfrens.com/assets/home_claude.jpg",
    title: "Claude Monet",
    url: "https://x.com/artistmonet",
    username: "artistmonet",
  },
  {
    avatar: "https://cdn.botfrens.com/assets/home_vincent.jpg",
    title: "Vincent van Gogh",
    url: "https://x.com/vangoghartist",
    username: "vangoghartist",
  },
  {
    avatar: "https://cdn.botfrens.com/assets/home_edward.jpg",
    title: "Edward Hopper",
    url: "https://x.com/artisthopper",
    username: "artisthopper",
  },
  {
    avatar: "https://cdn.botfrens.com/assets/home_rene.jpg",
    title: "René Magritte",
    url: "https://x.com/artistmagritte",
    username: "artistmagritte",
  },
  {
    avatar: "https://cdn.botfrens.com/assets/home_gustav.jpg",
    title: "Gustav Klimt",
    url: "https://x.com/artistgklimt",
    username: "artistgklimt",
  },
  {
    avatar: "https://cdn.botfrens.com/assets/home_salvador.jpg",
    title: "Salvador Dalí",
    url: "https://x.com/artist_dali",
    username: "artist_dali",
  },
];
